const BannerClick = (link) => {
    window.location.href = link;
};

document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('.product__info-sub-product details');

  detailsElements.forEach(detail => {
    detail.addEventListener('click', function (event) {
      if (detail.open) {
        detail.removeAttribute('open');

        const nextProductInfo = detail.closest('.product__info-sub-product').nextElementSibling;
        if (nextProductInfo && nextProductInfo.querySelector('details')) {
          nextProductInfo.querySelector('details').setAttribute('open', 'open');
        }
      }
    });
  });
});
